// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_-BZ86","devide":"index_devide_CqMFt","hairlines":"index_hairlines_nA6H9"};